import React from 'react';

export const FooterHeading = props => {
    return <h5 className="footer-heading"> { props.heading } </h5>
}